<template>
 
  <router-view/>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import { ElConfigProvider } from "element-plus";
import { Options, Vue } from 'vue-class-component';
 
import Layheard from '@/components/lay-heard/index.vue';
@Options({
  components: {
   Layheard
  },
})
export default class HomeView extends Vue {}
</script>


<style lang="scss">
 

 
</style>
